// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel {
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.table {
  width: 100%;
  margin-top: 1rem;
}

th, td {
  text-align: left;
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/usercountreport/usercountreport.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AACF;;AACA;EACE,WAAA;EACA,gBAAA;AAEF;;AAAA;EACE,gBAAA;EACA,eAAA;AAGF","sourcesContent":[".panel {\n  padding: 2rem;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n.table {\n  width: 100%;\n  margin-top: 1rem;\n}\nth, td {\n  text-align: left;\n  padding: 0.5rem;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
